/**
 * Simple utility function for creating variable payloads based on type
 * @author Abhishek Dhillon
 */

/**
 * Creates payload based on selectedVariable type using payload builder hooks
 * @param {Object} selectedVariable - The selected variable object
 * @param {Object} payloadBuilders - Object containing payload builder hook functions
 * @param {Function} payloadBuilders.buildDropdownPayload - Dropdown payload builder
 * @param {Function} payloadBuilders.buildTextPayload - Text payload builder
 * @param {Function} payloadBuilders.buildDatePayload - Date payload builder
 * @param {Function} payloadBuilders.buildNumberPayload - Number payload builder
 * @param {Function} payloadBuilders.buildPayload - Generic payload builder
 * @returns {Object|null} The payload object or null if no selectedVariable
 * @author Abhishek Dhillon
 */
export const createPayloadByType = (selectedVariable, payloadBuilders) => {
  if (!selectedVariable) {
    return null;
  }

  const { buildDropdownPayload, buildTextPayload, buildDatePayload, buildNumberPayload, buildPayload } = payloadBuilders;

  // Get variable type from selectedVariable
  const variableType = selectedVariable?.variableType || selectedVariable?.type;

  // Build payload based on variable type using existing hooks
  switch (variableType?.toLowerCase()) {
    case "dropdown":
      return buildDropdownPayload();
    case "text":
      return buildTextPayload();
    case "date":
      return buildDatePayload();
    case "number":
      return buildNumberPayload();
    default:
      // Use generic builder for unknown types
      return buildPayload(variableType);
  }
};
